<template>
    <van-popup class="van-popup-radius" :value="showCalendarDatePop" position="bottom"  @click-overlay="clickCancel">
        <van-datetime-picker
            v-if="currentTab == 1"
            v-model="currentCalendarDate"
            type="date"
            title="选择日期"
            cancel-button-text="<"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="clickCancel"
            @confirm="clickConfirm" />
        <van-picker 
            v-if="currentTab == 2"
            show-toolbar 
            title="选择日期" 
            cancel-button-text="<"
            :columns="lunarColumns"
            @change="onChangeLunar"
            @cancel="clickCancel"
            @confirm="clickConfirmLunar" />
    </van-popup>
</template>

<script>
import { CALENDAR } from '../../modules/calendar/calendar';
import { CONST_CALENDAR_END_YEAR } from '../../modules/data/base/consts'
import { FORMAT } from '../../modules/data/core/format';
export default {
    name: 'CalendarDatePop',
    computed: {
        currentTab() {
            return this.$store.state.calendar.currentTab;
        },
        showCalendarDatePop() {
            return this.$store.state.calendar.showCalendarDatePop;
        },
        currentCalendarDate: {
            get() {
                return this.$store.state.calendar.currentCalendarDate;
            },
            set(value) {
                this.$store.state.calendar.currentCalendarDate = value;
            }
        } 
    },
    data() {
        return {
            minDate: new Date(CONST_CALENDAR_END_YEAR[0], 0, 1),
            maxDate: new Date(CONST_CALENDAR_END_YEAR[1], 0, 1),
            lunarColumns: []
        }
    },
    mounted() {
        this.$bus.on('updateCalendarDatePop', this.initLunarData);
    },
    destroyed() {
        this.$bus.off('updateCalendarDatePop', this.initLunarData);
    },
    methods: {
        clickCancel() {
            this.$store.state.calendar.showCalendarDatePop = false;
        },
        clickConfirm(value) {
            this.$store.state.calendar.showCalendarDatePop = false;
            var currentTab = this.$store.state.calendar.currentTab;
            var year = value.getFullYear(),
                month = value.getMonth(),
                day = value.getDate();
            this.$bus.emit('selectCalendar', {
                value: [year, month, day],
                calType: currentTab
            })
        },
        initLunarData(data) {
            this.lunarColumns = CALENDAR.getCurrentLunarYMDArrayByData(data);
        },
        onChangeLunar(picker, value) {
            var lY = FORMAT.getNumberByChineseWord('year', value[0]),
                lM = FORMAT.getNumberByChineseWord('month', value[1]),
                lD = FORMAT.getNumberByChineseWord('day', value[2]);
            var newDaysArr = CALENDAR.getCurrentLunarDArrayByYM(lY, lM);
            // 更新设置日的天数
            picker.setColumnValues(2, newDaysArr);
            // console.log('onChangeLunar--------', lY, lM, lD)
        },
        clickConfirmLunar(value) {
            this.$store.state.calendar.showCalendarDatePop = false;
            var lY = FORMAT.getNumberByChineseWord('year', value[0]),
                lM = FORMAT.getNumberByChineseWord('month', value[1]),
                lD = FORMAT.getNumberByChineseWord('day', value[2]),
                isLeap = CALENDAR.leapMonth(lY, lM) != 0 && CALENDAR.leapMonth(lY, lM) == lM ? 1 : 0,
                currentTab = this.$store.state.calendar.currentTab;
            var solarObj = CALENDAR.lunar2solar(lY, lM, lD, isLeap);
            // console.log('clickConfirmLunar--------', lY, lM, lD, isLeap, solarObj);
            this.$bus.emit('selectCalendar', {
                value: [solarObj.cYear, solarObj.cMonth-1, solarObj.cDay],
                calType: currentTab
            });
        }
    }
}
</script>